import { Card } from "@magnetic/card";
import { User as UserIcon } from "@magnetic/icons";
import { Tag } from "@magnetic/tag";
import { Text } from "@magnetic/text";

import { HFlex } from "src/components/hFlex";
import { Icon } from "src/components/icons";
import { VFlex } from "src/components/vFlex";

interface StepCardProps {
  readonly stepNumber: number;
  readonly title: string;
  readonly description: string;
  readonly descriptionHighlightText?: string;
  readonly badgeText: string;
  readonly iconName: string;
  readonly badgeClassName: string;
}
export const StepCard = ({
  stepNumber,
  title,
  description,
  descriptionHighlightText,
  badgeText,
  iconName,
  badgeClassName
}: StepCardProps) => {
  const shouldHighlightDescriptionText =
    descriptionHighlightText &&
    description.startsWith(descriptionHighlightText);
  const descriptionSuffix = shouldHighlightDescriptionText
    ? description.slice(descriptionHighlightText.length)
    : description;

  return (
    <Card className="step-card">
      <VFlex gap="md">
        <HFlex justify="space-between" align="center">
          <HFlex align="center" gap="sm">
            <div className="step-number">{stepNumber}</div>
            <Text weight="bold" size="p3">
              {title}
            </Text>
          </HFlex>
          <Tag className={`step-badge ${badgeClassName}`}>
            <span className="step-badge-icon">
              <UserIcon size={12} weight="regular" />
            </span>
            <span className="step-badge-text"> {badgeText} </span>
          </Tag>
        </HFlex>

        <HFlex gap="md" align="center">
          <VFlex className="step-icon">
            <Icon name={iconName} size="lg" />
          </VFlex>
          <VFlex gap="xs" className="step-description">
            <Text size="p4" color="light">
              {shouldHighlightDescriptionText && descriptionHighlightText ? (
                <>
                  <span className="step-description-title">
                    {descriptionHighlightText}
                  </span>
                  {descriptionSuffix}
                </>
              ) : (
                description
              )}
            </Text>
          </VFlex>
        </HFlex>
      </VFlex>
    </Card>
  );
};
